import { render, staticRenderFns } from "./RolloverFormDownload.vue?vue&type=template&id=87c2cb94&scoped=true"
import script from "./RolloverFormDownload.vue?vue&type=script&lang=ts"
export * from "./RolloverFormDownload.vue?vue&type=script&lang=ts"
import style0 from "./RolloverFormDownload.vue?vue&type=style&index=0&id=87c2cb94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c2cb94",
  null
  
)

export default component.exports